import React, { useMemo } from "react";
import { Panel } from "./ui";

/** data: [{ day, dayIdx, cells: [{ hour, value }] }] */
const ActivityHeatmap = ({ data, loading, error, onRetry }) => {
  const max = useMemo(() => {
    if (!data) return 1;
    return Math.max(1, ...data.flatMap((d) => d.cells.map((c) => c.value)));
  }, [data]);

  const hours = data?.[0]?.cells.map((c) => c.hour) || [];

  const cellColor = (value) => {
    const intensity = value / max;
    if (intensity === 0) return "bg-gray-50";
    if (intensity < 0.25) return "bg-indigo-100";
    if (intensity < 0.5) return "bg-indigo-300";
    if (intensity < 0.75) return "bg-indigo-500";
    return "bg-indigo-700";
  };

  return (
    <Panel
      eyebrow="פעילות"
      title="שעות וימי פעילות"
      subtitle="באילו ימים ושעות מתקיימים הכי הרבה שיעורים"
      accent="slate"
      loading={loading}
      error={error}
      onRetry={onRetry}
      empty={!loading && !error && (!data || data.length === 0)}
    >
      <div className="overflow-x-auto">
        <div style={{ minWidth: `${hours.length * 26 + 40}px` }}>
          <div className="flex items-center gap-0.5 pr-9">
            {hours.map((h) => (
              <span key={h} className="w-6 text-center text-[9px] text-gray-400 font-semibold">{h}</span>
            ))}
          </div>
          {data?.map((row) => (
            <div key={row.day} className="flex items-center gap-0.5 mt-0.5">
              <span className="w-8 text-[10px] font-bold text-gray-500 flex-shrink-0">{row.day}</span>
              {row.cells.map((c) => (
                <div
                  key={c.hour}
                  title={`${row.day} ${c.hour}:00 — ${c.value} פעילויות`}
                  className={`w-6 h-6 rounded-[4px] flex-shrink-0 ${cellColor(c.value)}`}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-1.5 mt-3 text-[10px] text-gray-400">
        <span>פחות</span>
        {["bg-gray-50", "bg-indigo-100", "bg-indigo-300", "bg-indigo-500", "bg-indigo-700"].map((c) => (
          <span key={c} className={`w-3.5 h-3.5 rounded-[3px] ${c}`} />
        ))}
        <span>יותר</span>
      </div>
    </Panel>
  );
};

export default ActivityHeatmap;
